import * as React from 'react';
import { ClosedLoopAssignType } from '@nkr/enums/index';

export interface IDonorSearchContext {
    centerId: number,
    selectedIndex: number
    doExpand: (index: number) => void,
    doDisplayDashSearch: () => void,
    doDisplayCreate: (type: ClosedLoopAssignType) => void,
    doDisplayFindDonor: () => void,
    doDisplayFindDsd: () => void,
    doMarkDonated: (identifier: string) => void
}

export const DonorSearchContext = React.createContext<IDonorSearchContext | null>(null);
export const DonorSearchProvider = DonorSearchContext.Provider;